import * as yup from 'yup';

const EMAIL_DOMAIN_REGEX =
  /^(?:(?:[a-z0-9\u00A1-\uFFFF](?:[a-z0-9\u00A1-\uFFFF-]{0,61}[a-z0-9\u00A1-\uFFFF])?)\.)+(?:[a-z\u00A1-\uFFFF]{2,}|xn--[a-z0-9-]{2,})$/i;

export function isCheckoutEmailValid(email: string) {
  if (/\s/.test(email)) {
    return false;
  }

  const emailParts = email.split('@');

  if (emailParts.length !== 2) {
    return false;
  }

  const [localPart, domain] = emailParts;

  return (
    Boolean(localPart) &&
    Boolean(domain) &&
    !localPart.startsWith('.') &&
    !localPart.endsWith('.') &&
    !localPart.includes('..') &&
    EMAIL_DOMAIN_REGEX.test(domain)
  );
}

export function getCheckoutEmailSchema({
  invalidMessage,
  required = true,
  requiredMessage,
}: {
  invalidMessage: string;
  required?: boolean;
  requiredMessage: string;
}) {
  const schema = yup
    .string()
    .trim()
    .test('checkout-email', invalidMessage, (value) => {
      if (!value) {
        return true;
      }

      return isCheckoutEmailValid(value);
    });

  return required ? schema.required(requiredMessage) : schema.notRequired();
}
